module.exports = __webpack_public_path__ + "images/setting_1.png";